/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// Composables
import { ru } from 'vuetify/locale'
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          complete: '#ccf5f9',
          canceled: '#a3a5b3',
          canceled_by_customer: '#a3a5b3',
          canceled_by_nanny: '#a3a5b3',
          canceled_by_service: '#a3a5b3',
          planned: '#f7c3a6',
          requested: '#8be78f',
          applied: '#FEF49B',
          workinghours: '#7CA4F3',
          unworkinghours: '#eee',
          brandGreen: '#59cb5e',
          brandLightGreen: '#8be78f',
          brandOrange: '#ffb47e',
          brandPink: '#ffe8fa',
          brandGray: '#35363b',
          brandWhite: '#ffffff',
        }
      },
      gray: {
        colors: {
          background: '#eee',
          surface: '#eee',
          brandGreen: '#59cb5e',
          brandLightGreen: '#8be78f',
          brandOrange: '#ffb47e',
        }
      }
    },
  },
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  defaults: {
    VBtn: {
      color: '#35363b',
      
    },
  },
})
